import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { GraphQLQuery } from '@aws-amplify/api';
import { KnowledgeMapsByOwnerIdQuery } from '@core/graphql/custom.types';
import { KnowledgeMap, KnowledgeMapsByOwnerIdQueryVariables } from 'kms-amplify/src';

@Injectable({
  providedIn: 'root',
})
export class KmapService {
  constructor() {}

  async getKmapByOwner(id: string): Promise<Array<KnowledgeMap | null>> {
    const variables: KnowledgeMapsByOwnerIdQueryVariables = {
      ownerId: id,
    };

    const response = await API.graphql<GraphQLQuery<KnowledgeMapsByOwnerIdQuery>>({
      query: `
      query KnowledgeMapsByOwnerId(
        $ownerId: ID!
        $sortDirection: ModelSortDirection
        $filter: ModelKnowledgeMapFilterInput
        $limit: Int
        $nextToken: String
      ) {
        knowledgeMapsByOwnerId(
          ownerId: $ownerId
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            createdAt
            id
            name
            ownerId
            updatedAt
            businessProcesses {
              __typename
              items {
                __typename
                strategicActivities {
                  __typename
                  items {
                    __typename
                    importantKnowledges {
                      __typename
                      items {
                        __typename
                        documents {
                          __typename
                          items {
                            __typename
                            document {
                              __typename
                              createdAt
                              createdById
                              filename
                              filetype
                              folderId
                              id
                              updatedAt
                            }
                            createdAt
                            creatorId
                            documentId
                            documentType
                            id
                            importantKnowledgeId
                            updatedAt
                          }
                          nextToken
                        }
                        createdAt
                        description
                        id
                        strategicActivityId
                        title
                        updatedAt
                      }
                      nextToken
                    }
                    businessProcessId
                    createdAt
                    description
                    id
                    title
                    updatedAt
                  }
                  nextToken
                }
                updatedAt
                title
                createdAt
                description
                id
                knowledgeMapId
              }
              nextToken
            }
            collaborators {
              __typename
              items {
                __typename
                employee {
                  __typename
                  user {
                    __typename
                    name
                    id
                    username
                    email
                    updatedAt
                    createdAt
                  }
                  userId
                  nik
                  updatedAt
                  createdAt
                }
                employeeId
                updatedAt
                knowledgeMapId
                id
                createdAt
              }
              nextToken
            }
          }
          nextToken
        }
      }
      `,
      variables,
    });

    const items = response?.data?.knowledgeMapsByOwnerId?.items;
    if (items && items?.length > 0) {
      return items;
    }
    return [];
  }
}
